export default __webpack_public_path__ + "static/media/Eye_6_F_C3.94ea3e9e.svg";